<template>
  <span>
    <v-chip
      label
      small
      text-color="white"
      :color="category.colour"
      v-for="category of categories"
      :key="category.slug"
      @click="onCategoryClick(category)"
    >
      <v-avatar>
        <v-icon>{{ category.icon }}</v-icon>
      </v-avatar>
      {{ category.name }}
    </v-chip>
  </span>
</template>

<script>

export default {
  name: 'StrollCategories',

  props: {
    categories: Array,
    onCategoryClick: Function,
  }
}

</script>
